
<component :is="tag" :class="classes" :role="role">
  <template v-if="isHeading">
    <h6><slot></slot></h6>
  </template>
  <template v-else>
    <slot></slot>
  </template>
</component>
